import { FC } from 'react';
import { Accordion } from '@/components/accordion';
import { platformAdminNestedOrganisationNavItems } from '@/data/platform-admin-nested-organisation-nav-items';
import { useOrganisations } from '@/hooks/use-organisations';
import { usePlatformAdminOrganisationOverride } from '@/hooks/use-platform-admin-organisation-override';
import { NavLinks } from '../components/sidebar/nav-links';

export const NestedOrganisationNavLinks: FC = () => {
  const { orgId: currentOrgId } = usePlatformAdminOrganisationOverride();
  const { data: organisations } = useOrganisations();

  return (
    <>
      {organisations.map(({ id, name }) => {
        const orgNavItems = platformAdminNestedOrganisationNavItems.map(
          (item) => ({
            ...item,
            to: typeof item.to === 'function' ? item.to({ id }) : item.to,
          }),
        );

        return (
          <Accordion id={id} key={id} open={currentOrgId === id} title={name}>
            <div className="pl-4">
              <NavLinks items={orgNavItems} />
            </div>
          </Accordion>
        );
      })}
    </>
  );
};
